import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {environment} from '../../environments/environment';
import {HttpErrorResponse} from '@angular/common/http';
import {AuthenticationService} from '../_services';
import * as CryptoJS from 'crypto-js';


@Component({
  
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit  {

  public login = {'email': '', 'password': '', 'userType': 'pcb'};
  public logo: string = environment.halfLogoWhite;
  public stateCode: string = environment.stateCode;
  public state: string = environment.state;

  loginForm: UntypedFormGroup;
  public result;
  isLoginError = false;
  loading = false;
  submitted = false;
  returnUrl: string;
  isLoader = false;
  action_from;
  projectId;
  mode;
  generatedCaptcha: string;
  isCaptchaError = false;

  private salt = CryptoJS.enc.Hex.parse('68656c6c6f3132333435363738393031'); // 16-byte hex salt
  private iv = CryptoJS.enc.Hex.parse('69763132333435363738393031323334'); // 16-byte hex IV
  private keySize = 256 / 32; // 32 bytes (256 bits)
  private iterations = 1000;
  private secret = 'key121'; // Must match Laravel secret key
  errorMsg = '';


  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.generateCaptcha();

    this.loginForm = this.formBuilder.group({
      'name': new UntypedFormControl('', [Validators.required]),
      'password': new UntypedFormControl('', [Validators.required]),
      'userType': new UntypedFormControl('pcb', [Validators.required]),
      'captcha': new UntypedFormControl('', [Validators.required])

    });

    const token = localStorage.getItem('userToken');

    if (!token) {
      localStorage.removeItem('userToken');
      localStorage.removeItem('userData');
      this.router.navigate(['login']);
      // location.reload();
    } else {
      const userData = JSON.parse(localStorage.getItem('userData'));
      this.router.navigate(['dashboard']);
    }

  }

  get f() {
    return this.loginForm.controls;
  }

  ngAfterViewInit() {
    // Clear password field after render
    setTimeout(() => {
      this.loginForm.get('password')?.setValue('');
      this.generateRandomFieldName();
    }, 100);
  }

  encryptPassword() {
    const pass = this.encrypt(this.loginForm.value.password);

    // this.loginForm.patchValue({
    //   password: pass
    // });
    console.log('password encrypted', this.loginForm.value);

    this.loginUser(pass);
  }
  loginUser(pass) {

    this.isCaptchaError = false;

    const token = localStorage.getItem('userToken');
    this.isLoader = true;
    if (token) {
      const userData = JSON.parse(localStorage.getItem('userData'));
      return true;
    }
    this.submitted = true;

    console.log('login', this.encrypt(this.loginForm.value.password));
    const loginData = {
        name: this.encrypt(this.loginForm.value.name),
        // password: pass,
        password: this.encrypt(this.loginForm.value.password),
        //userType: this.loginForm.value.userType,    // plain
        userType: this.encrypt(this.loginForm.value.userType),
      captcha: this.loginForm.value.captcha
    };
 
    console.log('login data', loginData);

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.isLoader = false;
      return;
    }

    // if (!this.validateCaptcha()) {
    //   this.isCaptchaError = true;
    //   this.generateCaptcha();
    //   this.isLoader = false;
    //   return;
    // }

    // if (!this.validateCaptcha()) {
    //   this.isCaptchaError = true;
    //   // this.generateCaptcha();
    //   this.isLoader = false;
    //   return;
    // }
    this.loading = true;
    console.log('FINAL PAYLOAD', loginData);
    // this.authenticationService.login(this.f.name.value, this.f.password.value)
    this.authenticationService.userLogin(loginData).subscribe((data: any) => {

        console.log(data);
        if (data.status && (data.status === 406 || data.status === 422)) {
          this.errorMsg = data.msg;
          this.isLoginError = true;
          this.loading = false;
          this.isLoader = false;
          return;
        }

        if (data.message === 'unverified') {

        } else {

          if (this.loginForm.value.userType === 'industry') {
            data.userData.access_level = 'industry';
            data.userData.user_profile_id = data.userData.id;
          }

          localStorage.setItem('userToken', data.token.token);
          const userDataJSON = JSON.stringify(data.userData);
          localStorage.setItem('userData', userDataJSON);

          const profileData = JSON.stringify(data.profileData);
          localStorage.setItem('profileData', profileData);

          this.router.navigate(['dashboard']);
        }

      },
      (error: HttpErrorResponse) => {
        this.errorMsg = 'Incorrect username or password';
        this.isLoginError = true;
        this.isLoader = false;
        this.loading = false;
      }
    );


  }


  encrypt(password: string): string {
    // Generate a key using PBKDF2 with SHA-512
    const key = CryptoJS.PBKDF2(this.secret, this.salt, {
      keySize: this.keySize,
      iterations: this.iterations,
      hasher: CryptoJS.algo.SHA512,
    });

    // Encrypt password using AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(password, key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext); // Return Base64 encrypted string
  }

  generateCaptcha() {

    this.authenticationService.generateCaptcha().subscribe((data: any) => {
        console.log('this is captacha', data.captcha);
        this.generatedCaptcha = data.captcha;
        const canvas = document.getElementById('myCanvas') as HTMLCanvasElement;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        ctx.font = '20px Comic Sans MS';
        ctx.fillStyle = 'red';
        ctx.textAlign = 'center';
        ctx.fillText(this.generatedCaptcha, canvas.width / 2, canvas.height / 1.5);

        // Draw a line through the text
        const textWidth = ctx.measureText(this.generatedCaptcha).width;
        const textHeight = parseInt(ctx.font, 10);
        ctx.beginPath();
        ctx.moveTo(canvas.width / 2 - textWidth / 2, canvas.height / 1.5 - textHeight / 2.5);
        ctx.lineTo(canvas.width / 2 + textWidth / 2, canvas.height / 1.5 - textHeight / 2.5);
        ctx.strokeStyle = 'blue'; // Change line color if needed
        ctx.stroke();
      },
      (error: HttpErrorResponse) => {
        console.log('error', error);
      }
    );


    // const alphabets = 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz';
    // const first = alphabets[Math.floor(Math.random() * alphabets.length)];
    // const second = Math.floor(Math.random() * 10);
    // const third = Math.floor(Math.random() * 10);
    // const fourth = alphabets[Math.floor(Math.random() * alphabets.length)];
    // const fifth = alphabets[Math.floor(Math.random() * alphabets.length)];
    // const sixth = Math.floor(Math.random() * 10);
    // this.generatedCaptcha = first.toString() +
    //   second.toString() +
    //   third.toString() +
    //   fourth.toString() +
    //   fifth.toString() +
    //   sixth.toString();
    // console.log('generated captcha: ' + this.generatedCaptcha);
    //

  }


  private validateCaptcha() {


    return this.loginForm.value.captcha === this.generatedCaptcha;
  }

  removeReadOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.removeAttribute('readonly');
  }

  generateRandomFieldName() {
    return 'pass-' + Math.random().toString(36).substring(2, 15);
  }
  // attemptLogin(){
  //   this.router.navigate(['/dashboard']);
  // }
}
